"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./downloadCredentialDropdown.scss");
const react_1 = require("react");
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const download_arrow_down_svg_1 = __importDefault(require("../../../assets/images/icons/download-arrow-down.svg"));
const download_arrow_up_svg_1 = __importDefault(require("../../../assets/images/icons/download-arrow-up.svg"));
const BaseInput_1 = __importDefault(require("../../../elementKit/baseInput/BaseInput"));
const react_2 = __importDefault(require("react"));
const json_icon_svg_1 = __importDefault(require("../../../assets/images/icons/json-icon.svg"));
const download_icon_svg_1 = __importDefault(require("../../../assets/images/icons/download-icon.svg"));
const elementKit_1 = require("../../../elementKit");
const styled_components_1 = __importDefault(require("styled-components"));
const react_svg_1 = require("react-svg");
const master_1 = require("../../../constants/master");
const Notification_1 = __importDefault(require("../../../elementKit/notification/Notification"));
const ConditionalTooltipWrapper_1 = __importDefault(require("../../common/conditionalTooltipWrapper/ConditionalTooltipWrapper"));
const StyledDownloadCredentialDropdown = styled_components_1.default.div `
  .customizable-icon .injected-svg {
    fill: ${(props) => props.primaryColor} !important;
    stroke: none !important;
  }

  .dropdown-menu.show {
    border: 1px solid ${(props) => props.primaryColor} !important;
  }

  .disabled {
    .base-input {
      pointer-events: none;
      border: 2px solid #8f8f8f !important;
    }

    .base-input::placeholder {
      color: #8f8f8f !important;
    }

    .customizable-icon .injected-svg {
      fill: #8f8f8f !important;
    }
  }
`;
function DownloadCredentialDropdown(props) {
    var _a, _b, _c;
    const wrapperRef = (0, react_1.useRef)(null);
    const [dropdownToggle, setDropdownToggle] = (0, react_1.useState)(false);
    const [activeIcon, setActiveIcon] = (0, react_1.useState)(download_arrow_down_svg_1.default);
    const config = (0, master_1.getMasterConfig)();
    (0, react_1.useEffect)(() => {
        if (dropdownToggle) {
            setActiveIcon(download_arrow_up_svg_1.default);
        }
        else {
            setActiveIcon(download_arrow_down_svg_1.default);
        }
    }, [dropdownToggle]);
    const showLoader = (key) => {
        switch (key) {
            case "0":
                return props.isCertificatePngLoading || false;
            case "1":
                return props.isBadgePngLoading || false;
            case "2":
                return props.isQrLoading || false;
            case "3":
                return props.isPdfLoading || false;
            case "4":
                return props.isJsonLoading || false;
            default:
                return false;
        }
    };
    return (react_2.default.createElement(StyledDownloadCredentialDropdown, { primaryColor: config.primaryColor, containerBackgroundColor: config.containerBackgroundColor },
        react_2.default.createElement(ConditionalTooltipWrapper_1.default, { enableTooltip: (props.disabled &&
                !((_a = props.disabledButtonTooltipOptions) === null || _a === void 0 ? void 0 : _a.showNotificationInsteadTooltip)) ||
                false, tooltipOptions: {
                content: (_b = props.disabledButtonTooltipOptions) === null || _b === void 0 ? void 0 : _b.text,
                place: "top",
            }, children: react_2.default.createElement(Dropdown_1.default, { id: `download-dropdown-basic-button${props.isMobile ? "-mobile" : ""}`, onSelect: (newValue) => props.onChangeAction(newValue), onToggle: (nextShow) => {
                    var _a;
                    if (props.disabled &&
                        ((_a = props.disabledButtonTooltipOptions) === null || _a === void 0 ? void 0 : _a.showNotificationInsteadTooltip)) {
                        (0, Notification_1.default)({
                            type: props.disabledButtonTooltipOptions.tooltipType,
                            text: props.disabledButtonTooltipOptions.text,
                        });
                        return;
                    }
                    if (!props.disabled) {
                        setDropdownToggle(nextShow);
                    }
                }, show: props.disabled ? false : dropdownToggle, style: Object.assign({}, props.wrapperStyles), className: `dropdown ${props.disabled ? "disabled" : ""}`, autoClose: "outside" },
                react_2.default.createElement(Dropdown_1.default.Toggle, { disabled: props.disabled &&
                        !((_c = props.disabledButtonTooltipOptions) === null || _c === void 0 ? void 0 : _c.showNotificationInsteadTooltip) },
                    react_2.default.createElement("div", { className: "base-dropdown flex-column jc-sb", ref: wrapperRef },
                        react_2.default.createElement(BaseInput_1.default, { className: "dropdown-input", width: props.width, height: props.height, placeholder: props.placeholder, value: props.value, onBlurAction: () => {
                                if (props.disabled)
                                    return;
                                setActiveIcon(download_arrow_down_svg_1.default);
                            }, onFocusAction: () => {
                                if (props.disabled)
                                    return;
                                setActiveIcon(download_arrow_up_svg_1.default);
                            }, styles: Object.assign(Object.assign({}, props.styles), { fontSize: "15px", fontStyle: "normal", fontWeight: 400, lineHeight: "normal" }) }),
                        react_2.default.createElement(react_svg_1.ReactSVG, { className: "customizable-icon", wrapper: "svg", src: activeIcon, height: 9, width: 15, style: {
                                position: "absolute",
                                right: "18px",
                                top: `20px`,
                            } }),
                        props.helperText ? (react_2.default.createElement("div", { className: "flex-row", style: { width: "100%" } },
                            react_2.default.createElement("span", { className: "helper-text" }, props.helperText))) : (react_2.default.createElement("div", { className: "sized-box", style: { height: "10px" } })))),
                react_2.default.createElement(Dropdown_1.default.Menu, null, props.dropdownOptions.map((option, i) => (react_2.default.createElement(Dropdown_1.default.Item, { eventKey: option.key, key: option.key },
                    react_2.default.createElement("div", { className: "download-option" },
                        react_2.default.createElement("span", { className: "download-text" }, option.label),
                        showLoader(option.key) ? (react_2.default.createElement(elementKit_1.Loader, { width: 20, height: 20, type: "primary" })) : option.key !== "4" ? (react_2.default.createElement(react_svg_1.ReactSVG, { className: "customizable-icon", wrapper: "svg", src: download_icon_svg_1.default, height: 20, width: 20 })) : (react_2.default.createElement(react_svg_1.ReactSVG, { className: "customizable-icon", wrapper: "svg", src: json_icon_svg_1.default, height: 13, style: { marginRight: "3px" }, width: 13 })))))))) })));
}
exports.default = DownloadCredentialDropdown;
